/* eslint-disable */
<template>
  <v-container class="text-left">
    <v-row class="text-left">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card
          color="primary"
          icon="mdi-cellphone-dock"
          inline
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="body-1 font-weight-bold mb-2">
                Создание заказа на оплату
              </h1>
            </div>
          </template>
          <v-card-title class="mt-n5">
            Информация о плательщике
          </v-card-title>
          <v-card-text class="caption mt-n1">
            <v-form v-model="valid.main">
              <v-row
                dense
              >
                <v-col
                  cols="12"
                  md="6"
                  class="mt-n5 xs"
                >
                  <v-text-field
                    v-model="form.payer.fullname"
                    prepend-icon="mdi-account"
                    label="ФИО"
                    :readonly="dialog.view || form.payer.id"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"

                  class="mt-n5 xs"
                >
                  <v-autocomplete
                    v-model="selected.payer"
                    prepend-icon="mdi-account-search"
                    editable
                    :filter="name_filter"
                    :items="select.payers"
                    label="Поиск клиента"
                    :readonly="dialog.view"
                    clearable
                    @change="name_change"
                  >
                    <template v-slot:selection="{item}">
                      {{ item.name }}
                    </template>
                    <template v-slot:item="{item}">
                      <v-list
                        two-line
                        class="text-left"
                      >
                        <v-list-item-content>
                          <v-list-item-title> {{ item.fullname }} {{ item.doc.series }}-{{ item.doc.number }}</v-list-item-title>
                          <v-list-item-subtitle>{{ item.address }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="3"

                  class="mt-n5 xs"
                >
                  <v-select
                    v-model="form.payer.doc.type"
                    prepend-icon="mdi-passport"
                    :items="select.doc_type"
                    label="Тип документа"
                    :readonly="dialog.view"
                    @change="form.payer.doc.series = '', form.payer.doc.number = ''"
                  />
                </v-col>
                <v-col
                  v-if="form.payer.doc.type!=14 && form.payer.doc.type!=21"
                  cols="12"
                  md="3"

                  class="mt-n5 xs"
                >
                  <v-text-field
                    v-model="form.payer.doc.series"
                    label="Серия документа"
                    :readonly="dialog.view"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"

                  class="mt-n5 xs"
                >
                  <v-text-field
                    v-model="form.payer.doc.number"
                    :rules="[(v) => check_doc(form.payer.doc.type, v) || 'Неверное значение']"
                    label="Номер документа"
                    :readonly="dialog.view"
                  />
                </v-col>
                <v-col
                  v-if="form.payer.documents && form.payer.documents.length>1"
                  cols="12"
                  md="3"

                  class="mt-n5 xs"
                >
                  <v-select
                    v-model="selected.doc"
                    prepend-icon="mdi-passport"
                    :items="form.payer.documents"
                    label="Документы плательщика"
                    :readonly="dialog.view"
                    return-object
                    item-text="type_name"
                    @change="doc_change"
                  />
                </v-col>
                <v-col
                  cols="12"
                  class="mt-n5"
                >
                  <v-text-field
                    v-model="form.payer.address"
                    prepend-icon="mdi-map-marker"
                    name="address"
                    label="Адрес"
                    :readonly="dialog.view"
                    @input="address_input"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"

                  class="mt-n5 xs"
                >
                  <v-text-field
                    v-model="form.payer.phone"
                    prepend-icon="mdi-cellphone-basic"
                    label="Телефон (в формате 7XXXXXXXXX)"
                    :readonly="dialog.view"
                    type="phone"
                    :counter="11"
                    maxlength="11"
                    :rules="[(v) => /7\d{10}/.test(v) || 'Неверное значение']"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"

                  class="mt-n5 xs"
                >
                  <v-text-field
                    v-model="form.payer.email"
                    prepend-icon="mdi-at"
                    label="E-mail"
                    :readonly="dialog.view"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"

                  class="mt-n3 xs"
                >
                  <v-row dense>
                    <v-col cols="12">
                      Информация о платеже
                    </v-col>
                    <v-col
                      cols="12"
                      class="mt-n5"
                    >
                      <v-text-field
                        v-model="form.recipient.uin"
                        label="Уникальный индекс начисления (УИН)"
                        :readonly="dialog.view"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      class="mt-n5"
                    >
                      <v-text-field
                        v-model="form.recipient.kbk"
                        label="КБК"
                        :counter="20"
                        maxlength="20"
                        :rules="[(v) => check_doc('kbk', v) || 'Неверное значение']"
                        @input="check_comission"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"

                      class="mt-n5 xs"
                    >
                      <v-autocomplete
                        v-model="form.recipient.oktmo"
                        editable
                        :filter="oktmo_filter"
                        :items="select.oktmo"
                        item-value="number"
                        label="ОКТМО"
                        :readonly="dialog.view"
                        maxlength="8"
                        @input="check_comission"
                      >
                        <template v-slot:selection="{item}">
                          {{ item.number }}
                        </template>
                        <template v-slot:item="{item}">
                          <v-list
                            two-line
                            class="text-left"
                          >
                            <v-list-item-content>
                              <v-list-item-title> {{ item.number }}</v-list-item-title>
                              <v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"

                      class="mt-n5 mb-n5 xs"
                    >
                      <v-text-field
                        v-model="form.sum"
                        label="Сумма"
                        :readonly="dialog.view"
                        :hint="comission_hint"
                        persistent-hint
                        @input="check_comission"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  md="6"

                  class="mt-n3 xs"
                >
                  <v-row dense>
                    <v-col
                      cols="12"
                      class="mt-3"
                    >
                      Назначение платежа
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="form.description"
                        label="Назначение"
                        rows="6"
                        :readonly="dialog.view"
                        :counter="210"
                        maxlength="210"
                        @input="check_comission"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="mt-n5">
            <v-btn
              color="secondary"
              min-width="100"
              @click="dialog.show = false, load_payers(), selected = { doc: null, payer: null}"
            >
              Закрыть
            </v-btn>
            <v-btn
              v-if="dialog.create"
              class="text--right"
              color="primary"
              min-width="100"
              :disabled="!valid.main || !valid.recipient"
              @click="create(), selected = { doc: null, payer: null}"
            >
              Создать
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-col>
      <v-col

        cols="12"
        md="4"
      >
        <v-form v-model="valid.recipient">
          <v-row>
            <v-col cols="12">
              <base-material-card
                color="primary"
                icon="mdi-cellphone-dock"
                inline
              >
                <template v-slot:heading>
                  <div class="text-center">
                    <h1 class="body-1 font-weight-bold mb-2">
                      Информация о получателе
                    </h1>
                  </div>
                </template>
                <v-card-title class="mt-n7">
                  Реквизиты получателя
                </v-card-title>
                <v-card-text class="text-left mb-n10">
                  <v-row
                    dense
                  >
                    <v-col
                      class="mt-n5"
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.recipient.name_full"
                        name="recipient_name"
                        label="Наименование"
                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="recipient_input"
                      />
                    </v-col>
                    <v-col
                      class="mt-n5"
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.recipient.name"
                        label="Получатель"
                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="check_comission"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"

                      class="mt-n5 xs"
                    >
                      <v-text-field

                        v-model="form.recipient.inn"
                        name="recipient_inn"
                        label="ИНН"
                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="recipient_input"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"

                      class="mt-n5 xs"
                    >
                      <v-text-field
                        v-model="form.recipient.kpp"
                        name="recipient_kpp"
                        label="КПП"
                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="recipient_input"
                      />
                    </v-col>

                    <v-col
                      cols="8"
                      class="mt-n5"
                    >
                      <v-text-field
                        v-model="form.recipient.accnumber"
                        label="Расчетный счет"
                        :readonly="dialog.view || !dialog.no_recipient"

                        @input="check_comission"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"

                      class="mt-n5 xs"
                    >
                      <v-text-field
                        v-model="form.recipient.bik"
                        name="bank_bik"
                        label="БИК"
                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="bank_input"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.recipient.bankname"
                        name="bank_name"
                        label="Банк получателя"
                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="bank_input"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      class="mt-n5 caption"
                    >
                      <v-text-field
                        v-model="form.recipient.ks"
                        name="bank_ks"
                        label="К/с"

                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="bank_input"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </base-material-card>
            </v-col>
            <v-col
              cols="12"
              class="mt-n5"
            >
              <base-material-card
                color="primary"
                icon="mdi-cellphone-dock"
                inline
              >
                <template v-slot:heading>
                  <div class="text-center">
                    <h1 class="body-1 font-weight-bold mb-n2">
                      Действия
                    </h1>
                  </div>
                </template>
                <v-card-text class="text-center">
                  <v-row class="mt-n5 mb-n5">
                    <v-col

                      cols="12"
                      md="4"
                    >
                      <v-icon
                        size="30"
                        :disabled="!form.id"
                        color="primary"
                        @click="resend"
                      >
                        mdi-reload
                      </v-icon>
                      <br><span class="caption">Повторить</span>
                    </v-col>
                    <v-col

                      cols="12"
                      md="4"
                    >
                      <v-icon
                        size="30"
                        :disabled="form.state!=5000"
                        color="primary"
                        @click="receipt"
                      >
                        mdi-receipt
                      </v-icon>
                      <br><span class="caption">Квитанция</span>
                    </v-col>
                    <v-col

                      cols="12"
                      md="4"
                    >
                      <v-icon
                        size="30"
                        :disabled="form.state!=2000"
                        color="primary"
                        @click="confirm.show = true, confirm.item = form"
                      >
                        mdi-file-undo
                      </v-icon>
                      <br><span
                        class="caption"
                      >Отозвать</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </base-material-card>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-dialog
      v-model="confirm.show"
      max-width="250"
    >
      <v-container>
        <v-card>
          <v-card-title>Отозвать платеж?</v-card-title>
          <v-card-actions>
            <v-btn
              width="100"
              color="secondary"
              @click="confirm.show = false"
            >
              Назад
            </v-btn>
            <v-btn
              width="100"
              color="primary"
              @click="recall(confirm.item)"
            >
              Да
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-dialog>
    <v-dialog
      v-model="state.show"
      max-width="450"
    >
      <v-container>
        <v-card>
          <v-card-title>Результат</v-card-title>
          <v-card-text class="title text-left">
            Статус заказа: <b>{{ dict.state[state.item.state] }}</b><br>
            Выберите дальнейшее действие
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col

                cols="12"
                md="6"
              >
                <v-icon
                  size="64"
                  color="primary"
                  @click="state.show = false, dialog.show = false, $router.push('/common/order/list')"
                >
                  mdi-file-document
                </v-icon>
                <br>
                Перейти к списку заказов
              </v-col>
              <v-col

                cols="12"
                md="6"
              >
                <v-icon
                  size="64"
                  color="primary"
                  @click="state.show = false, dialog.show = false, $router.push('/common/services')"
                >
                  mdi-credit-card-outline
                </v-icon>
                <br>
                Перейти к оплате услуг
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-dialog>
  </v-container>
</template>
<script>
  import $ from 'jquery'
  import suggest from '../../libs/suggestions.min.17.12.0.dev.js'
  import { mask, tokens, TheMask } from 'vue-the-mask'
  export default {
    props: {
      service: {
        type: String,
      },
      form: {
        type: Object,
        default: function () {
          return {

            recipient: {
              name: '',
              name_full: '',
              inn: '',
              kpp: '',
              bankname: '',
              bik: '',
              ks: '',
            },
            payer: {
              doc: {
                type: '',
                series: '',
                number: '',
              },
              address: '',
              email: '',
              phone: '',
              inn: '',
            },
          }
        },
      },
      dialog: {
        type: Object,
        default: function () {
          return {
            show: false,
            create: true,
            view: false,
            no_recipient: false,
          }
        },
      },
    },
    data: () => {
      return {
        service_item: null,
        selected: {
          doc: null,
          payer: null,
        },
        valid: {
          main: false,
          recipient: false,
        },
        comission: 0,
        state: {
          show: false,
          item: {},
        },
        mask: {
          phone: '+7(###)###-##-##',
        },
        suggestion: {
          address: false,
          recipient: false,
          bank: false,
        },
        confirm: {
          item: {},
          show: false,
        },
        dict: {
          state: {
            2000: 'Принят',
            3000: 'В обработке',
            4000: 'Отложен',
            5000: 'Завершен',
            6000: 'Отвергнут',
            7000: 'Отозван',
          },
          mfc: {},
          doc_type: {
            1: 'Паспорт гражданина Российской Федерации',
            2: 'Свидетельство о рождении',
            3: 'Паспорт моряка (удостоверение личности моряка)',
            4: 'Удостоверение личности военнослужащего ',
            5: 'Военный билет военнослужащего',
            6: 'Временное удостоверение личности гражданина Российской Федерации',
            7: 'Справка об освобождении из мест лишения свободы',
            8: 'Паспорт иностранного гражданина либо иной документ, установленный федеральным законом или признаваемый в соответствии с международным договором Российской Федерации в качестве документа, удостоверяющего личность иностранного гражданина',
            9: 'Вид на жительство ',
            10: 'Разрешение на временное проживание (для лиц без гражданства)',
            11: 'Удостоверение беженца',
            12: 'Миграционная карта',
            13: 'Паспорт гражданина СССР',
            14: 'CНИЛС',
            21: 'ИНН',
            22: 'Водительское удостоверение',
            24: 'Свидетельство о регистрации транспортного средства в органах Министерства внутренних дел Российской Федерации',
            25: 'Охотничий билет',
            26: 'Разрешение на хранение и ношение охотничьего оружия',
            28: 'Загранпаспорт',
            29: 'Свидетельство о предоставлении временного убежища на территории Российской Федерации',
            30: 'Свидетельство о рассмотрении ходатайства по существу',
            99: 'Иной',
          },
        },
        select: {
          oktmo: [{ number: '80601404', name: 'Альмухаметовский' },
                  { number: '80601407', name: 'Амангельдинский' },
                  { number: '80601410', name: 'Аскаровский' },
                  { number: '80601413', name: 'Баимовский' },
                  { number: '80601416', name: 'Бурангуловский' },
                  { number: '80601419', name: 'Гусевский' },
                  { number: '80601422', name: 'Давлетовский' },
                  { number: '80601425', name: 'Кирдасовский' },
                  { number: '80601428', name: 'Краснобашкирский' },
                  { number: '80601431', name: 'Равиловский' },
                  { number: '80601434', name: 'Ташбулатовский' },
                  { number: '80601437', name: 'Таштимеровский' },
                  { number: '80601440', name: 'Халиловский' },
                  { number: '80601443', name: 'Хамитовский' },
                  { number: '80601446', name: 'Янгильский' },
                  { number: '80602404', name: 'Абдрашитовский' },
                  { number: '80602406', name: 'Аксеновский' },
                  { number: '80602413', name: 'Воздвиженский' },
                  { number: '80602416', name: 'Гайниямакский' },
                  { number: '80602418', name: 'Зеленоклиновский' },
                  { number: '80602419', name: 'Ибраевский' },
                  { number: '80602422', name: 'Казанский' },
                  { number: '80602428', name: 'Кармышевский' },
                  { number: '80602431', name: 'Кипчак-Аскаровский' },
                  { number: '80602437', name: 'Кызыльский' },
                  { number: '80602440', name: 'Мендяновский' },
                  { number: '80602443', name: 'Нигматуллинский' },
                  { number: '80602446', name: 'Нижнеаврюзовский' },
                  { number: '80602449', name: 'Никифаровский' },
                  { number: '80602451', name: 'Раевский' },
                  { number: '80602455', name: 'Слаковский' },
                  { number: '80602458', name: 'Ташлинский' },
                  { number: '80602461', name: 'Трунтаишевский' },
                  { number: '80602464', name: 'Чебенлинский' },
                  { number: '80602470', name: 'Шафрановский' },
                  { number: '80603404', name: 'Абзановский' },
                  { number: '80603410', name: 'Архангельский' },
                  { number: '80603413', name: 'Арх-Латышский' },
                  { number: '80603416', name: 'Бакалдинский' },
                  { number: '80603419', name: 'Инзерский' },
                  { number: '80603422', name: 'Ирныкшинский' },
                  { number: '80603425', name: 'Краснозилимский' },
                  { number: '80603428', name: 'Краснокуртовский' },
                  { number: '80603434', name: 'Липовский' },
                  { number: '80603440', name: 'Орловский' },
                  { number: '80603446', name: 'Тавакачевский' },
                  { number: '80603450', name: 'Узунларовский' },
                  { number: '80604402', name: 'Арбашевский' },
                  { number: '80604404', name: 'Аскинский' },
                  { number: '80604413', name: 'Евбулякский' },
                  { number: '80604416', name: 'Казанчинский' },
                  { number: '80604418', name: 'Карткисякский' },
                  { number: '80604419', name: 'Кашкинский' },
                  { number: '80604425', name: 'Ключевский' },
                  { number: '80604428', name: 'Кубиязовский' },
                  { number: '80604431', name: 'Кунгаковский' },
                  { number: '80604437', name: 'Кшлау-Елгинский' },
                  { number: '80604440', name: 'Мутабашевский' },
                  { number: '80604442', name: 'Петропавловский' },
                  { number: '80604443', name: 'Султанбековский' },
                  { number: '80604446', name: 'Урмиязовский' },
                  { number: '80604450', name: 'Усть-Табасский' },
                  { number: '80605402', name: 'Балыклыкульский' },
                  { number: '80605404', name: 'Батыровский' },
                  { number: '80605407', name: 'Бишкаинский' },
                  { number: '80605410', name: 'Ибраевский' },
                  { number: '80605413', name: 'Исмагиловский' },
                  { number: '80605416', name: 'Ишлинский' },
                  { number: '80605419', name: 'Кебячевский' },
                  { number: '80605422', name: 'Меселинский' },
                  { number: '80605425', name: 'Михайловский' },
                  { number: '80605428', name: 'Нагадакский' },
                  { number: '80605431', name: 'Новокальчировский' },
                  { number: '80605434', name: 'Семенкинский' },
                  { number: '80605437', name: 'Степановский' },
                  { number: '80605440', name: 'Султанмуратовский' },
                  { number: '80605443', name: 'Таштамакский' },
                  { number: '80605446', name: 'Толбазинский' },
                  { number: '80605449', name: 'Тряпинский' },
                  { number: '80605452', name: 'Тукаевский' },
                  { number: '80605458', name: 'Турумбетовский' },
                  { number: '80605461', name: 'Уршакский' },
                  { number: '80605472', name: 'Чуваш-Карамалинский' },
                  { number: '80606404', name: 'Абдулкаримовский' },
                  { number: '80606407', name: 'Акмурунский' },
                  { number: '80606409', name: 'Бекешевский' },
                  { number: '80606410', name: 'Биляловский' },
                  { number: '80606413', name: 'Зилаирский' },
                  { number: '80606416', name: 'Иткуловский 1-й' },
                  { number: '80606422', name: 'Ишмурзинский' },
                  { number: '80606425', name: 'Ишмухаметовский' },
                  { number: '80606428', name: 'Ишбердинский' },
                  { number: '80606431', name: 'Кусеевский' },
                  { number: '80606434', name: 'Мукасовский' },
                  { number: '80606437', name: 'Кульчуровский' },
                  { number: '80606438', name: 'Мирясовский' },
                  { number: '80606440', name: 'Нигаматовский' },
                  { number: '80606442', name: 'Семеновский' },
                  { number: '80606443', name: 'Сибайский' },
                  { number: '80606446', name: 'Тавлыкаевский' },
                  { number: '80606449', name: 'Татлыбаевский' },
                  { number: '80606452', name: 'Темясовский' },
                  { number: '80606453', name: 'Тубинский' },
                  { number: '80606455', name: 'Юмашевский' },
                  { number: '80606459', name: 'Яратовский' },
                  { number: '80607404', name: 'Ахмановский' },
                  { number: '80607407', name: 'Бакалинский' },
                  { number: '80607410', name: 'Михайловский' },
                  { number: '80607413', name: 'Бузюровский' },
                  { number: '80607419', name: 'Дияшевский' },
                  { number: '80607425', name: 'Камышлытамакский' },
                  { number: '80607428', name: 'Килеевский' },
                  { number: '80607431', name: 'Куштиряковский' },
                  { number: '80607434', name: 'Мустафинский' },
                  { number: '80607440', name: 'Новокатаевский' },
                  { number: '80607446', name: 'Новоурсаевский' },
                  { number: '80607449', name: 'Старокуручевский' },
                  { number: '80607451', name: 'Старокостеевский' },
                  { number: '80607455', name: 'Староматинский' },
                  { number: '80607458', name: 'Старошарашлинский' },
                  { number: '80607461', name: 'Тактагуловский' },
                  { number: '80607464', name: 'Урманаевский' },
                  { number: '80608404', name: 'Богдановский' },
                  { number: '80608407', name: 'Верхнеянактаевский' },
                  { number: '80608413', name: 'Кундашлинский' },
                  { number: '80608416', name: 'Кунтугушевский' },
                  { number: '80608419', name: 'Нижнекарышевский' },
                  { number: '80608422', name: 'Нижнесикиязовский' },
                  { number: '80608425', name: 'Норкинский' },
                  { number: '80608428', name: 'Сейтяковский' },
                  { number: '80608431', name: 'Старобалтачевский' },
                  { number: '80608434', name: 'Староянбаевский' },
                  { number: '80608437', name: 'Тошкуровский' },
                  { number: '80608440', name: 'Тучубаевский' },
                  { number: '80608441', name: 'Шавьядинский' },
                  { number: '80608443', name: 'Штандинский' },
                  { number: '80608448', name: 'Ялангачевский' },
                  { number: '80609165', name: 'Приютово' },
                  { number: '80609401', name: 'Аксаковский' },
                  { number: '80609402', name: 'Баженовский' },
                  { number: '80609404', name: 'Донской' },
                  { number: '80609407', name: 'Ермолкинский' },
                  { number: '80609410', name: 'Знаменский' },
                  { number: '80609413', name: 'Анновский' },
                  { number: '80609416', name: 'Максим-Горьковский' },
                  { number: '80609419', name: 'Малиновский' },
                  { number: '80609425', name: 'Метевбашевский' },
                  { number: '80609428', name: 'Рассветовский' },
                  { number: '80609431', name: 'Семенкинский' },
                  { number: '80609434', name: 'Слакбашевский' },
                  { number: '80609437', name: 'Тузлукушевский' },
                  { number: '80609440', name: 'Усень-Ивановский' },
                  { number: '80609443', name: 'Шаровский' },
                  { number: '80610402', name: 'Атаршинский' },
                  { number: '80610404', name: 'Белянковский' },
                  { number: '80610407', name: 'Емашинский' },
                  { number: '80610413', name: 'Карлыхановский' },
                  { number: '80610416', name: 'Майгазинский' },
                  { number: '80610419', name: 'Нижнеискушинский' },
                  { number: '80610422', name: 'Новобелокатайский' },
                  { number: '80610425', name: 'Ногушинский' },
                  { number: '80610428', name: 'Старобелокатайский' },
                  { number: '80610431', name: 'Тардавский' },
                  { number: '80610434', name: 'Ургалинский' },
                  { number: '80610437', name: 'Утяшевский' },
                  { number: '80610440', name: 'Яныбаевский' },
                  { number: '80611404', name: 'Абзаковский' },
                  { number: '80611407', name: 'Азикеевский' },
                  { number: '80611410', name: 'Ассинский' },
                  { number: '80611415', name: 'Верхнеавзянский' },
                  { number: '80611416', name: 'Зигазинский' },
                  { number: '80611417', name: 'Зуяковский' },
                  { number: '80611418', name: 'Железнодорожный' },
                  { number: '80611420', name: 'Инзерский' },
                  { number: '80611422', name: 'Ишлинский' },
                  { number: '80611425', name: 'Кагинский' },
                  { number: '80611427', name: 'Ломовский' },
                  { number: '80611434', name: 'Николаевский' },
                  { number: '80611440', name: 'Нурский' },
                  { number: '80611443', name: 'Серменевский' },
                  { number: '80611446', name: 'Сосновский' },
                  { number: '80611448', name: 'Тирлянский' },
                  { number: '80611449', name: 'Туканский' },
                  { number: '80611452', name: 'Узянский' },
                  { number: '80611455', name: 'Шигаевский' },
                  { number: '80612404', name: 'Аитовский' },
                  { number: '80612407', name: 'Базлыкский' },
                  { number: '80612410', name: 'Бижбулякский' },
                  { number: '80612413', name: 'Биккуловский' },
                  { number: '80612416', name: 'Демский' },
                  { number: '80612419', name: 'Елбулактамакский' },
                  { number: '80612422', name: 'Зириклинский' },
                  { number: '80612425', name: 'Калининский' },
                  { number: '80612428', name: 'Каменский' },
                  { number: '80612431', name: 'Кенгер-Менеузовский' },
                  { number: '80612440', name: 'Кош-Елгинский' },
                  { number: '80612442', name: 'Михайловский' },
                  { number: '80612443', name: 'Сухореченский' },
                  { number: '80613407', name: 'Бахтыбаевский' },
                  { number: '80613408', name: 'Бурновский' },
                  { number: '80613409', name: 'Березовский' },
                  { number: '80613410', name: 'Верхнелачентауский' },
                  { number: '80613416', name: 'Калинниковский' },
                  { number: '80613419', name: 'Кусекеевский' },
                  { number: '80613422', name: 'Маядыковский' },
                  { number: '80613425', name: 'Осиновский' },
                  { number: '80613431', name: 'Силантьевский' },
                  { number: '80613434', name: 'Старобазановский' },
                  { number: '80613437', name: 'Старопетровский' },
                  { number: '80613440', name: 'Сусловский' },
                  { number: '80613443', name: 'Угузевский' },
                  { number: '80613446', name: 'Чишминский' },
                  { number: '80614404', name: 'Алексеевский' },
                  { number: '80614407', name: 'Балышлинский' },
                  { number: '80614410', name: 'Благоварский' },
                  { number: '80614413', name: 'Дмитриевский' },
                  { number: '80614416', name: 'Каргалинский' },
                  { number: '80614419', name: 'Кашкалашинский' },
                  { number: '80614422', name: 'Кучербаевский' },
                  { number: '80614423', name: 'Мирновский' },
                  { number: '80614424', name: 'Первомайский' },
                  { number: '80614428', name: 'Тановский' },
                  { number: '80614431', name: 'Троицкий' },
                  { number: '80614434', name: 'Удрякбашевский' },
                  { number: '80614437', name: 'Языковский' },
                  { number: '80614440', name: 'Ямакаевский' },
                  { number: '80614443', name: 'Янышевский' },
                  { number: '80615404', name: 'Бедеево-Полянский' },
                  { number: '80615407', name: 'Богородский' },
                  { number: '80615413', name: 'Волковский' },
                  { number: '80615419', name: 'Изяковский' },
                  { number: '80615422', name: 'Иликовский' },
                  { number: '80615425', name: 'Ильино-Полянский' },
                  { number: '80615428', name: 'Николаевский' },
                  { number: '80615431', name: 'Новонадеждинский' },
                  { number: '80615434', name: 'Октябрьский' },
                  { number: '80615437', name: 'Орловский' },
                  { number: '80615440', name: 'Покровский' },
                  { number: '80615443', name: 'Саннинский' },
                  { number: '80615449', name: 'Старонадеждинский' },
                  { number: '80615453', name: 'Тугайский' },
                  { number: '80615461', name: 'Удельно-Дуванейский' },
                  { number: '80617404', name: 'Араслановский' },
                  { number: '80617407', name: 'Буздякский' },
                  { number: '80617410', name: 'Гафурийский' },
                  { number: '80617413', name: 'Канлы-Туркеевский' },
                  { number: '80617416', name: 'Каранский' },
                  { number: '80617419', name: 'Килимовский' },
                  { number: '80617422', name: 'Копейкубовский' },
                  { number: '80617425', name: 'Кузеевский' },
                  { number: '80617431', name: 'Сабаевский' },
                  { number: '80617437', name: 'Тавларовский' },
                  { number: '80617440', name: 'Тюрюшевский' },
                  { number: '80617446', name: 'Уртакульский' },
                  { number: '80618404', name: 'Азяковский' },
                  { number: '80618407', name: 'Бадраковский' },
                  { number: '80618413', name: 'Бураевский' },
                  { number: '80618416', name: 'Ванышевский' },
                  { number: '80618419', name: 'Вострецовский' },
                  { number: '80618422', name: 'Каинлыковский' },
                  { number: '80618425', name: 'Кашкалевский' },
                  { number: '80618428', name: 'Кушманаковский' },
                  { number: '80618431', name: 'Кузбаевский' },
                  { number: '80618437', name: 'Тазларовский' },
                  { number: '80618440', name: 'Тангатаровский' },
                  { number: '80618443', name: 'Тепляковский' },
                  { number: '80618446', name: 'Челкаковский' },
                  { number: '80619404', name: 'Аскаровский' },
                  { number: '80619407', name: 'Атиковский' },
                  { number: '80619409', name: 'Байгазинский' },
                  { number: '80619410', name: 'Байназаровский' },
                  { number: '80619413', name: 'Галиакберовский' },
                  { number: '80619416', name: 'Иргизлинский' },
                  { number: '80619419', name: 'Киекбаевский' },
                  { number: '80619420', name: 'Кипчакский' },
                  { number: '80619422', name: 'Старомунасиповский' },
                  { number: '80619425', name: 'Старосубхангуловский' },
                  { number: '80619430', name: 'Тимировский' },
                  { number: '80619440', name: 'Кулганинский' },
                  { number: '80621407', name: 'Белоозерский' },
                  { number: '80621410', name: 'Бельский' },
                  { number: '80621413', name: 'Бурлинский' },
                  { number: '80621414', name: 'Буруновский' },
                  { number: '80621416', name: 'Зилим-Карановский' },
                  { number: '80621419', name: 'Имендяшевский' },
                  { number: '80621422', name: 'Ковардинский' },
                  { number: '80621423', name: 'Красноусольский' },
                  { number: '80621425', name: 'Мраковский' },
                  { number: '80621428', name: 'Саитбабинский' },
                  { number: '80621431', name: 'Табынский' },
                  { number: '80621434', name: 'Ташбукановский' },
                  { number: '80621437', name: 'Ташлинский' },
                  { number: '80621440', name: 'Толпаровский' },
                  { number: '80621443', name: 'Утяковский' },
                  { number: '80621446', name: 'Янгискаинский' },
                  { number: '80622404', name: 'Алгинский' },
                  { number: '80622410', name: 'Бик-Кармалинский' },
                  { number: '80622413', name: 'Ивановский' },
                  { number: '80622416', name: 'Имай-Кармалинский' },
                  { number: '80622419', name: 'Кадыргуловский' },
                  { number: '80622422', name: 'Казангуловский' },
                  { number: '80622425', name: 'Кидрячевский' },
                  { number: '80622428', name: 'Курманкеевский' },
                  { number: '80622431', name: 'Микяшевский' },
                  { number: '80622434', name: 'Поляковский' },
                  { number: '80622437', name: 'Раевский' },
                  { number: '80622440', name: 'Рассветовский' },
                  { number: '80622443', name: 'Сергиопольский' },
                  { number: '80622444', name: 'Соколовский' },
                  { number: '80622446', name: 'Чуюнчинский' },
                  { number: '80622449', name: 'Шестаевский' },
                  { number: '80623404', name: 'Ариевский' },
                  { number: '80623406', name: 'Вознесенский' },
                  { number: '80623407', name: 'Дуванский' },
                  { number: '80623413', name: 'Заимкинский' },
                  { number: '80623419', name: 'Лемазинский' },
                  { number: '80623422', name: 'Месягутовский' },
                  { number: '80623425', name: 'Метелинский' },
                  { number: '80623428', name: 'Михайловский' },
                  { number: '80623431', name: 'Рухтинский' },
                  { number: '80623433', name: 'Сальевский' },
                  { number: '80623434', name: 'Сикиязский' },
                  { number: '80623440', name: 'Улькундинский' },
                  { number: '80623443', name: 'Ярославский' },
                  { number: '80624404', name: 'Ангасякский' },
                  { number: '80624407', name: 'Асяновский' },
                  { number: '80624410', name: 'Исмаиловский' },
                  { number: '80624413', name: 'Куккуяновский' },
                  { number: '80624416', name: 'Маядыковский' },
                  { number: '80624422', name: 'Московский' },
                  { number: '80624430', name: 'Семилетовский' },
                  { number: '80624431', name: 'Старобаишевский' },
                  { number: '80624434', name: 'Староянтузовский' },
                  { number: '80624437', name: 'Суккуловский' },
                  { number: '80624440', name: 'Таймурзинский' },
                  { number: '80624443', name: 'Такарликовский' },
                  { number: '80624447', name: 'Учпилинский' },
                  { number: '80624449', name: 'Черлаковский' },
                  { number: '80625402', name: 'Бекетовский' },
                  { number: '80625404', name: 'Восьмомартовский' },
                  { number: '80625407', name: 'Ермекеевский' },
                  { number: '80625411', name: 'Кызыл-Ярский' },
                  { number: '80625413', name: 'Нижнеулу-Елгинский' },
                  { number: '80625416', name: 'Рятамакский' },
                  { number: '80625422', name: 'Спартакский' },
                  { number: '80625425', name: 'Среднекарамалинский' },
                  { number: '80625428', name: 'Старосуллинский' },
                  { number: '80625431', name: 'Старотураевский' },
                  { number: '80625434', name: 'Суккуловский' },
                  { number: '80625437', name: 'Тарказинский' },
                  { number: '80625440', name: 'Усман-Ташлинский' },
                  { number: '80626404', name: 'Абзановский' },
                  { number: '80626405', name: 'Абуляисовский' },
                  { number: '80626406', name: 'Баишевский' },
                  { number: '80626407', name: 'Байдавлетовский' },
                  { number: '80626410', name: 'Бикбауский' },
                  { number: '80626416', name: 'Исянгуловский' },
                  { number: '80626419', name: 'Казанбулакский' },
                  { number: '80626422', name: 'Муйнакский' },
                  { number: '80626425', name: 'Новопетровский' },
                  { number: '80626428', name: 'Новочебенкинский' },
                  { number: '80626431', name: 'Сакмарский' },
                  { number: '80626434', name: 'Суренский' },
                  { number: '80626437', name: 'Тазларовский' },
                  { number: '80626440', name: 'Утягуловский' },
                  { number: '80626443', name: 'Яныбаевский' },
                  { number: '80627404', name: 'Бердяшский' },
                  { number: '80627410', name: 'Верхнегалеевский' },
                  { number: '80627413', name: 'Дмитриевский' },
                  { number: '80627416', name: 'Зилаирский' },
                  { number: '80627419', name: 'Ивано-Кувалатский' },
                  { number: '80627421', name: 'Кананикольский' },
                  { number: '80627422', name: 'Канзафаровский' },
                  { number: '80627423', name: 'Кашкаровский' },
                  { number: '80627425', name: 'Матраевский' },
                  { number: '80627432', name: 'Сабыровский' },
                  { number: '80627434', name: 'Уркасский' },
                  { number: '80627436', name: 'Юлдыбаевский' },
                  { number: '80627442', name: 'Ямансазский' },
                  { number: '80628403', name: 'Акбердинский' },
                  { number: '80628405', name: 'Ауструмский' },
                  { number: '80628410', name: 'Балтийский' },
                  { number: '80628415', name: 'Ивано-Казанский' },
                  { number: '80628416', name: 'Иглинский' },
                  { number: '80628420', name: 'Калтымановский' },
                  { number: '80628425', name: 'Кальтовский' },
                  { number: '80628430', name: 'Красновосходский' },
                  { number: '80628432', name: 'Кудеевский' },
                  { number: '80628435', name: 'Лемезинский' },
                  { number: '80628440', name: 'Майский' },
                  { number: '80628445', name: 'Надеждинский' },
                  { number: '80628450', name: 'Охлебининский' },
                  { number: '80628455', name: 'Тавтимановский' },
                  { number: '80628460', name: 'Турбаслинский' },
                  { number: '80628470', name: 'Уктеевский' },
                  { number: '80628472', name: 'Улу-Телякский' },
                  { number: '80628474', name: 'Урманский' },
                  { number: '80628480', name: 'Чуваш-Кубовский' },
                  { number: '80630404', name: 'Аккузевский' },
                  { number: '80630408', name: 'Андреевский' },
                  { number: '80630412', name: 'Базитамакский' },
                  { number: '80630416', name: 'Бишкураевский' },
                  { number: '80630424', name: 'Дюмеевский' },
                  { number: '80630426', name: 'Игметовский' },
                  { number: '80630428', name: 'Исаметовский' },
                  { number: '80630432', name: 'Исанбаевский' },
                  { number: '80630436', name: 'Итеевский' },
                  { number: '80630440', name: 'Ишкаровский' },
                  { number: '80630444', name: 'Кадыровский' },
                  { number: '80630448', name: 'Карабашевский' },
                  { number: '80630452', name: 'Кужбахтинский' },
                  { number: '80630456', name: 'Новомедведевский' },
                  { number: '80630460', name: 'Рсаевский' },
                  { number: '80630464', name: 'Старокуктовский' },
                  { number: '80630468', name: 'Сюльтинский' },
                  { number: '80630472', name: 'Урметовский' },
                  { number: '80630476', name: 'Черекулевский' },
                  { number: '80630478', name: 'Юнновский' },
                  { number: '80630480', name: 'Ябалаковский' },
                  { number: '80630484', name: 'Яркеевский' },
                  { number: '80631405', name: 'Арметовский' },
                  { number: '80631415', name: 'Байгузинский' },
                  { number: '80631425', name: 'Верхоторский' },
                  { number: '80631430', name: 'Иткуловский' },
                  { number: '80631435', name: 'Ишеевский' },
                  { number: '80631440', name: 'Кузяновский' },
                  { number: '80631445', name: 'Кулгунинский' },
                  { number: '80631450', name: 'Макаровский' },
                  { number: '80631455', name: 'Петровский' },
                  { number: '80631460', name: 'Сайрановский' },
                  { number: '80631470', name: 'Скворчихинский' },
                  { number: '80631475', name: 'Урман-Бишкадакский' },
                  { number: '80631480', name: 'Янурусовский' },
                  { number: '80633000', name: 'Калтасинский район' },
                  { number: '80633403', name: 'Амзибашевский' },
                  { number: '80633405', name: 'Большекачаковский' },
                  { number: '80633415', name: 'Калегинский' },
                  { number: '80633420', name: 'Калмиябашевский' },
                  { number: '80633425', name: 'Калтасинский' },
                  { number: '80633430', name: 'Кельтеевский' },
                  { number: '80633445', name: 'Нижнекачмашевский' },
                  { number: '80633446', name: 'Новокильбахтинский' },
                  { number: '80633447', name: 'Краснохолмский' },
                  { number: '80633450', name: 'Тюльдинский' },
                  { number: '80633452', name: 'Старояшевский' },
                  { number: '80634404', name: 'Артакульский' },
                  { number: '80634412', name: 'Байкибашевский' },
                  { number: '80634416', name: 'Байкинский' },
                  { number: '80634424', name: 'Верхнесуянский' },
                  { number: '80634432', name: 'Караидельский' },
                  { number: '80634436', name: 'Караярский' },
                  { number: '80634440', name: 'Кирзинский' },
                  { number: '80634444', name: 'Куртлыкульский' },
                  { number: '80634445', name: 'Магинский' },
                  { number: '80634452', name: 'Новобердяшский' },
                  { number: '80634456', name: 'Новомуллакаевский' },
                  { number: '80634460', name: 'Озеркинский' },
                  { number: '80634464', name: 'Подлубовский' },
                  { number: '80634472', name: 'Староакбуляковский' },
                  { number: '80634480', name: 'Ургушевский' },
                  { number: '80634484', name: 'Урюш-Битуллинский' },
                  { number: '80634488', name: 'Явгильдинский' },
                  { number: '80635405', name: 'Адзитаровский' },
                  { number: '80635415', name: 'Бузовьязовский' },
                  { number: '80635420', name: 'Ефремкинский' },
                  { number: '80635423', name: 'Кабаковский' },
                  { number: '80635425', name: 'Камышлинский' },
                  { number: '80635430', name: 'Карламанский' },
                  { number: '80635435', name: 'Кармаскалинский' },
                  { number: '80635440', name: 'Николаевский' },
                  { number: '80635445', name: 'Новокиешкинский' },
                  { number: '80635450', name: 'Подлубовский' },
                  { number: '80635451', name: 'Прибельский' },
                  { number: '80635455', name: 'Савалеевский' },
                  { number: '80635465', name: 'Старобабичевский' },
                  { number: '80635470', name: 'Старомусинский' },
                  { number: '80635475', name: 'Сахаевский' },
                  { number: '80635480', name: 'Шаймуратовский' },
                  { number: '80636405', name: 'Абзаевский' },
                  { number: '80636410', name: 'Арслановский' },
                  { number: '80636415', name: 'Верхнекигинский' },
                  { number: '80636420', name: 'Еланлинский' },
                  { number: '80636425', name: 'Душанбековский' },
                  { number: '80636430', name: 'Ибраевский' },
                  { number: '80636435', name: 'Кандаковский' },
                  { number: '80636440', name: 'Леузинский' },
                  { number: '80636445', name: 'Нижнекигинский' },
                  { number: '80637405', name: 'Арлановский' },
                  { number: '80637410', name: 'Кариевский' },
                  { number: '80637412', name: 'Куяновский' },
                  { number: '80637415', name: 'Музяковский' },
                  { number: '80637420', name: 'Никольский' },
                  { number: '80637421', name: 'Николо-Березовский' },
                  { number: '80637425', name: 'Новобуринский' },
                  { number: '80637430', name: 'Новокабановский' },
                  { number: '80637435', name: 'Новокаинлыковский' },
                  { number: '80637440', name: 'Новонагаевский' },
                  { number: '80637443', name: 'Раздольевский' },
                  { number: '80637450', name: 'Саузбашевский' },
                  { number: '80637465', name: 'Шушнурский' },
                  { number: '80637461', name: 'Новоянзигитовский' },
                  { number: '80638405', name: 'Волостновский' },
                  { number: '80638410', name: 'Заречинский' },
                  { number: '80638415', name: 'Ибраевский' },
                  { number: '80638420', name: 'Ижбердинский' },
                  { number: '80638425', name: 'Иртюбякский' },
                  { number: '80638430', name: 'Исимовский' },
                  { number: '80638440', name: 'Кугарчинский' },
                  { number: '80638445', name: 'Максютовский' },
                  { number: '80638450', name: 'Мраковский' },
                  { number: '80638455', name: 'Нижнебиккузинский' },
                  { number: '80638460', name: 'Новопетровский' },
                  { number: '80638463', name: 'Нукаевский' },
                  { number: '80638470', name: 'Побоищенский' },
                  { number: '80638473', name: 'Санзяповский' },
                  { number: '80638475', name: 'Тляумбетовский' },
                  { number: '80638480', name: 'Уральский' },
                  { number: '80638483', name: 'Чапаевский' },
                  { number: '80638485', name: 'Юлдыбаевский' },
                  { number: '80638487', name: 'Юмагузинский' },
                  { number: '80638495', name: 'Ялчинский' },
                  { number: '80639410', name: 'Бахмутский' },
                  { number: '80639412', name: 'Ермолаевский' },
                  { number: '80639415', name: 'Илькинеевский' },
                  { number: '80639417', name: 'Зяк-Ишметовский' },
                  { number: '80639420', name: 'Кривле-Илюшкинский' },
                  { number: '80639425', name: 'Ленинский' },
                  { number: '80639435', name: 'Мурапталовский' },
                  { number: '80639440', name: 'Отрадинский' },
                  { number: '80639450', name: 'Свободинский' },
                  { number: '80639455', name: 'Таймасовский' },
                  { number: '80639460', name: 'Шабагишский' },
                  { number: '80639465', name: 'Якшимбетовский' },
                  { number: '80640405', name: 'Ахметовский' },
                  { number: '80640410', name: 'Бакаевский' },
                  { number: '80640415', name: 'Горьковский' },
                  { number: '80640430', name: 'Карача-Елгинский' },
                  { number: '80640435', name: 'Кушнаренковский' },
                  { number: '80640440', name: 'Матвеевский' },
                  { number: '80640465', name: 'Расмекеевский' },
                  { number: '80640470', name: 'Старогумеровский' },
                  { number: '80640475', name: 'Старокамышлинский' },
                  { number: '80640477', name: 'Старокурмашевский' },
                  { number: '80640480', name: 'Старотукмаклинский' },
                  { number: '80640490', name: 'Шариповский' },
                  { number: '80641402', name: 'Абитовский' },
                  { number: '80641405', name: 'Александровский' },
                  { number: '80641410', name: 'Аптраковский' },
                  { number: '80641415', name: 'Араслановский' },
                  { number: '80641422', name: 'Воскресенский' },
                  { number: '80641430', name: 'Зирганский' },
                  { number: '80641435', name: 'Денисовский' },
                  { number: '80641445', name: 'Иштугановский' },
                  { number: '80641450', name: 'Мелеузовский' },
                  { number: '80641455', name: 'Нордовский' },
                  { number: '80641460', name: 'Нугушевский' },
                  { number: '80641465', name: 'Партизанский' },
                  { number: '80641470', name: 'Первомайский' },
                  { number: '80641475', name: 'Сарышевский' },
                  { number: '80641480', name: 'Корнеевский' },
                  { number: '80641485', name: 'Шевченковский' },
                  { number: '80642401', name: 'Абдуллинский' },
                  { number: '80642405', name: 'Алегазовский' },
                  { number: '80642410', name: 'Большеокинский' },
                  { number: '80642415', name: 'Большеустьикинский' },
                  { number: '80642420', name: 'Дуван-Мечетлинский' },
                  { number: '80642423', name: 'Кургатовский' },
                  { number: '80642425', name: 'Лемез-Тамакский' },
                  { number: '80642430', name: 'Малоустьикинский' },
                  { number: '80642435', name: 'Новомещеровский' },
                  { number: '80642442', name: 'Новояушевский' },
                  { number: '80642445', name: 'Ростовский' },
                  { number: '80642450', name: 'Юнусовский' },
                  { number: '80643405', name: 'Акбулатовский' },
                  { number: '80643410', name: 'Баймурзинский' },
                  { number: '80643415', name: 'Большесухоязовский' },
                  { number: '80643420', name: 'Большешадинский' },
                  { number: '80643425', name: 'Ирсаевский' },
                  { number: '80643430', name: 'Кайраковский' },
                  { number: '80643435', name: 'Камеевский' },
                  { number: '80643445', name: 'Мавлютовский' },
                  { number: '80643450', name: 'Мишкинский' },
                  { number: '80643455', name: 'Новотроицкий' },
                  { number: '80643460', name: 'Староарзаматовский' },
                  { number: '80643465', name: 'Тынбаевский' },
                  { number: '80643470', name: 'Урьядинский' },
                  { number: '80643480', name: 'Чураевский' },
                  { number: '80644405', name: 'Биккуловский' },
                  { number: '80644410', name: 'Богдановский' },
                  { number: '80644415', name: 'Большекаркалинский' },
                  { number: '80644420', name: 'Енебей-Урсаевский' },
                  { number: '80644425', name: 'Зильдяровский' },
                  { number: '80644428', name: 'Ильчигуловский' },
                  { number: '80644429', name: 'Карановский' },
                  { number: '80644430', name: 'Качегановский' },
                  { number: '80644435', name: 'Кожай-Семеновский' },
                  { number: '80644440', name: 'Менеузтамакский' },
                  { number: '80644445', name: 'Миякибашевский' },
                  { number: '80644450', name: 'Миякинский' },
                  { number: '80644460', name: 'Новокарамалинский' },
                  { number: '80644465', name: 'Сатыевский' },
                  { number: '80644470', name: 'Уршакбашкарамалинский' },
                  { number: '80645405', name: 'Байгильдинский' },
                  { number: '80645410', name: 'Баш-Шидинский' },
                  { number: '80645415', name: 'Красногорский' },
                  { number: '80645416', name: 'Красноключевский' },
                  { number: '80645420', name: 'Никольский' },
                  { number: '80645435', name: 'Новокулевский' },
                  { number: '80645440', name: 'Новосубаевский' },
                  { number: '80645444', name: 'Павловский' },
                  { number: '80645445', name: 'Первомайский' },
                  { number: '80645450', name: 'Сарвинский' },
                  { number: '80645452', name: 'Старобедеевский' },
                  { number: '80645455', name: 'Староисаевский' },
                  { number: '80647405', name: 'Алькинский' },
                  { number: '80647410', name: 'Аркауловский' },
                  { number: '80647415', name: 'Ишимбаевский' },
                  { number: '80647425', name: 'Лагеревский' },
                  { number: '80647430', name: 'Лаклинский' },
                  { number: '80647435', name: 'Малоязовский' },
                  { number: '80647440', name: 'Мечетлинский' },
                  { number: '80647445', name: 'Мещегаровский' },
                  { number: '80647447', name: 'Мурсалимкинский' },
                  { number: '80647450', name: 'Насибашевский' },
                  { number: '80647476', name: 'Первомайский' },
                  { number: '80647453', name: 'Салаватский' },
                  { number: '80647455', name: 'Таймеевский' },
                  { number: '80647460', name: 'Терменевский' },
                  { number: '80647465', name: 'Турналинский' },
                  { number: '80647475', name: 'Янгантауский' },
                  { number: '80648402', name: 'Аллагуватский' },
                  { number: '80648405', name: 'Айдаралинский' },
                  { number: '80648410', name: 'Бакеевский' },
                  { number: '80648415', name: 'Бузатовский' },
                  { number: '80648418', name: 'Кабакушский' },
                  { number: '80648420', name: 'Карагушский' },
                  { number: '80648425', name: 'Куганакбашевский' },
                  { number: '80648430', name: 'Кундрякский' },
                  { number: '80648435', name: 'Сарайсинский' },
                  { number: '80648440', name: 'Старокалкашевский' },
                  { number: '80648445', name: 'Стерлибашевский' },
                  { number: '80648455', name: 'Тятер-Араслановский' },
                  { number: '80648460', name: 'Халикеевский' },
                  { number: '80648465', name: 'Янгурчинский' },
                  { number: '80648470', name: 'Яшергановский' },
                  { number: '80649404', name: 'Айгулевский' },
                  { number: '80649412', name: 'Алатанинский' },
                  { number: '80649416', name: 'Ашкадарский' },
                  { number: '80649418', name: 'Аючевский' },
                  { number: '80649420', name: 'Константиноградовский' },
                  { number: '80649424', name: 'Максимовский' },
                  { number: '80649428', name: 'Буриказгановский' },
                  { number: '80649436', name: 'Казадаевский' },
                  { number: '80649440', name: 'Куганакский' },
                  { number: '80649444', name: 'Красноярский' },
                  { number: '80649448', name: 'Наумовский' },
                  { number: '80649452', name: 'Николаевский' },
                  { number: '80649456', name: 'Отрадовский' },
                  { number: '80649460', name: 'Октябрьский' },
                  { number: '80649464', name: 'Первомайский' },
                  { number: '80649468', name: 'Подлесненский' },
                  { number: '80649478', name: 'Рощинский' },
                  { number: '80649480', name: 'Рязановский' },
                  { number: '80649488', name: 'Тюрюшлинский' },
                  { number: '80649492', name: 'Услинский' },
                  { number: '80650405', name: 'Акбулатовский' },
                  { number: '80650410', name: 'Аксаитовский' },
                  { number: '80650415', name: 'Бадряшевский' },
                  { number: '80650420', name: 'Буль-Кайпановский' },
                  { number: '80650425', name: 'Верхнетатышлинский' },
                  { number: '80650430', name: 'Кальмияровский' },
                  { number: '80650435', name: 'Кальтяевский' },
                  { number: '80650440', name: 'Кудашевский' },
                  { number: '80650445', name: 'Курдымский' },
                  { number: '80650450', name: 'Нижнебалтачевский' },
                  { number: '80650455', name: 'Новотатышлинский' },
                  { number: '80650460', name: 'Шулгановский' },
                  { number: '80650465', name: 'Ялгыз-Наратский' },
                  { number: '80651405', name: 'Бишкураевский' },
                  { number: '80651410', name: 'Верхнебишиндинский' },
                  { number: '80651415', name: 'Верхнетроицкий' },
                  { number: '80651417', name: 'Гафуровский' },
                  { number: '80651420', name: 'Ильчимбетовский' },
                  { number: '80651425', name: 'Какрыбашевский' },
                  { number: '80651427', name: 'Кандринский' },
                  { number: '80651430', name: 'Карамалы-Губеевский' },
                  { number: '80651435', name: 'Каратовский' },
                  { number: '80651439', name: 'Нижнетроицкий' },
                  { number: '80651440', name: 'Николаевский' },
                  { number: '80651445', name: 'Сайрановский' },
                  { number: '80651447', name: 'Серафимовский' },
                  { number: '80651455', name: 'Старотуймазинский' },
                  { number: '80651461', name: 'Субханкуловский' },
                  { number: '80651465', name: 'Татар-Улкановский' },
                  { number: '80651470', name: 'Тюменяковский' },
                  { number: '80651475', name: 'Чукадыбашевский' },
                  { number: '80652403', name: 'Алексеевский' },
                  { number: '80652405', name: 'Авдонский' },
                  { number: '80652410', name: 'Булгаковский' },
                  { number: '80652415', name: 'Дмитриевский' },
                  { number: '80652418', name: 'Жуковский' },
                  { number: '80652420', name: 'Зубовский' },
                  { number: '80652423', name: 'Кармасанский' },
                  { number: '80652425', name: 'Кирилловский' },
                  { number: '80652430', name: 'Красноярский' },
                  { number: '80652435', name: 'Миловский' },
                  { number: '80652440', name: 'Михайловский' },
                  { number: '80652450', name: 'Николаевский' },
                  { number: '80652452', name: 'Ольховский' },
                  { number: '80652455', name: 'Русско-Юрмашский' },
                  { number: '80652460', name: 'Таптыковский' },
                  { number: '80652472', name: 'Черкасский' },
                  { number: '80652473', name: 'Чесноковский' },
                  { number: '80652475', name: 'Шемякский' },
                  { number: '80652480', name: 'Юматовский' },
                  { number: '80653410', name: 'Амангильдинский' },
                  { number: '80653415', name: 'Ахуновский' },
                  { number: '80653416', name: 'Буйдинский' },
                  { number: '80653420', name: 'Ильчигуловский' },
                  { number: '80653425', name: 'Ильчинский' },
                  { number: '80653430', name: 'Имангуловский' },
                  { number: '80653440', name: 'Кирябинский' },
                  { number: '80653445', name: 'Кунакбаевский' },
                  { number: '80653448', name: 'Миндякский' },
                  { number: '80653449', name: 'Мансуровский' },
                  { number: '80653450', name: 'Наурузовский' },
                  { number: '80653455', name: 'Новобайрамгуловский' },
                  { number: '80653465', name: 'Поляковский' },
                  { number: '80653470', name: 'Сафаровский' },
                  { number: '80653484', name: 'Тунгатаровский' },
                  { number: '80653488', name: 'Уразовский' },
                  { number: '80653491', name: 'Уральский' },
                  { number: '80653496', name: 'Учалинский' },
                  { number: '80654405', name: 'Бала-Четырманский' },
                  { number: '80654410', name: 'Балыклинский' },
                  { number: '80654415', name: 'Булякаевский' },
                  { number: '80654416', name: 'Верхнеяушевский' },
                  { number: '80654417', name: 'Гончаровский' },
                  { number: '80654420', name: 'Дедовский' },
                  { number: '80654425', name: 'Денискинский' },
                  { number: '80654427', name: 'Каралачикский' },
                  { number: '80654430', name: 'Михайловский' },
                  { number: '80654440', name: 'Покровский' },
                  { number: '80654445', name: 'Пугачевский' },
                  { number: '80654450', name: 'Разинский' },
                  { number: '80654455', name: 'Теняевский' },
                  { number: '80654460', name: 'Федоровский' },
                  { number: '80655405', name: 'Абишевский' },
                  { number: '80655410', name: 'Акъюловский' },
                  { number: '80655415', name: 'Акъярский' },
                  { number: '80655420', name: 'Антинганский' },
                  { number: '80655424', name: 'Бурибайский' },
                  { number: '80655425', name: 'Ивановский' },
                  { number: '80655430', name: 'Маканский' },
                  { number: '80655432', name: 'Новозирганский' },
                  { number: '80655433', name: 'Самарский' },
                  { number: '80655435', name: 'Татыр-Узякский' },
                  { number: '80655440', name: 'Таналыкский' },
                  { number: '80655445', name: 'Уфимский' },
                  { number: '80655450', name: 'Федоровский' },
                  { number: '80655455', name: 'Целинный' },
                  { number: '80656410', name: 'Башировский' },
                  { number: '80656415', name: 'Имянликулевский' },
                  { number: '80656420', name: 'Калмашбашевский' },
                  { number: '80656425', name: 'Новобалтачевский' },
                  { number: '80656435', name: 'Новокутовский' },
                  { number: '80656440', name: 'Рапатовский' },
                  { number: '80656445', name: 'Резяповский' },
                  { number: '80656450', name: 'Старокалмашевский' },
                  { number: '80656455', name: 'Тайняшевский' },
                  { number: '80656460', name: 'Тузлукушевский' },
                  { number: '80656465', name: 'Урнякский' },
                  { number: '80656470', name: 'Чекмагушевский' },
                  { number: '80656475', name: 'Юмашевский' },
                  { number: '80657151', name: 'Чишмы' },
                  { number: '80657405', name: 'Алкинский' },
                  { number: '80657410', name: 'Аровский' },
                  { number: '80657415', name: 'Арслановский' },
                  { number: '80657420', name: 'Дмитриевский' },
                  { number: '80657425', name: 'Дурасовский' },
                  { number: '80657430', name: 'Енгалышевский' },
                  { number: '80657435', name: 'Еремеевский' },
                  { number: '80657440', name: 'Ибрагимовский' },
                  { number: '80657445', name: 'Кара-Якуповский' },
                  { number: '80657446', name: 'Лесной' },
                  { number: '80657450', name: 'Новотроицкий' },
                  { number: '80657455', name: 'Сафаровский' },
                  { number: '80657465', name: 'Чишминский' },
                  { number: '80657470', name: 'Чувалкиповский' },
                  { number: '80657475', name: 'Шингак-Кульский' },
                  { number: '80658405', name: 'Акбарисовский' },
                  { number: '80658410', name: 'Базгиевский' },
                  { number: '80658415', name: 'Дмитриево-Полянский' },
                  { number: '80658420', name: 'Дюртюлинский' },
                  { number: '80658425', name: 'Зириклинский' },
                  { number: '80658430', name: 'Мичуринский' },
                  { number: '80658435', name: 'Нижнезаитовский' },
                  { number: '80658440', name: 'Нижнеташлинский' },
                  { number: '80658445', name: 'Нуреевский' },
                  { number: '80658455', name: 'Писаревский' },
                  { number: '80658465', name: 'Старотумбагушевский' },
                  { number: '80658475', name: 'Чалмалинский' },
                  { number: '80658485', name: 'Шаранский' },
                  { number: '80659410', name: 'Асавдыбашский' },
                  { number: '80659415', name: 'Байгузинский' },
                  { number: '80659420', name: 'Воядинский' },
                  { number: '80659430', name: 'Ижболдинский' },
                  { number: '80659435', name: 'Истякский' },
                  { number: '80659440', name: 'Иткинеевский' },
                  { number: '80659445', name: 'Кармановский' },
                  { number: '80659450', name: 'Кисак-Каинский' },
                  { number: '80659453', name: 'Максимовский' },
                  { number: '80659455', name: 'Месягутовский' },
                  { number: '80659460', name: 'Новоартаульский' },
                  { number: '80659465', name: 'Орловский' },
                  { number: '80659470', name: 'Первомайский' },
                  { number: '80659475', name: 'Сандугачский' },
                  { number: '80659480', name: 'Староваряшский' },
                  { number: '80659485', name: 'Старокудашевский' },
                  { number: '80659490', name: 'Шудекский' },
                  { number: '80659495', name: 'Ямадинский' },
                  { number: '80701000', name: 'Уфа' },
                  { number: '80703000', name: 'Агидель' },
                  { number: '80606101', name: 'Баймак' },
                  { number: '80609101', name: 'Белебей' },
                  { number: '80611101', name: 'Белорецк' },
                  { number: '80613101', name: 'Бирск' },
                  { number: '80615101', name: 'Благовещенск' },
                  { number: '80624101', name: 'Дюртюли' },
                  { number: '80622101', name: 'Давлеканово' },
                  { number: '80631101', name: 'Ишимбай' },
                  { number: '80723000', name: 'Кумертау' },
                  { number: '80641101', name: 'Мелеуз' },
                  { number: '80727000', name: 'Нефтекамск' },
                  { number: '80735000', name: 'Октябрьский' },
                  { number: '80739000', name: 'Салават' },
                  { number: '80743000', name: 'Сибай' },
                  { number: '80745000', name: 'Стерлитамак' },
                  { number: '80651101', name: 'Туймазы' },
                  { number: '80653101', name: 'Учалы' },
                  { number: '80659101', name: 'Янаул' },
                  { number: '80707000', name: 'Межгорье' }],
          payers: [],
          doc_type: [
            { value: '01', text: 'Паспорт гражданина Российской Федерации' },
            { value: '02', text: 'Свидетельство о рождении' },
            { value: '03', text: 'Паспорт моряка (удостоверение личности моряка)' },
            { value: '04', text: 'Удостоверение личности военнослужащего ' },
            { value: '05', text: 'Военный билет военнослужащего' },
            { value: '06', text: 'Временное удостоверение личности гражданина Российской Федерации' },
            { value: '07', text: 'Справка об освобождении из мест лишения свободы' },
            { value: '08', text: 'Паспорт иностранного гражданина либо иной документ, установленный федеральным законом или признаваемый в соответствии с международным договором Российской Федерации в качестве документа, удостоверяющего личность иностранного гражданина' },
            { value: '09', text: 'Вид на жительство ' },
            { value: '10', text: 'Разрешение на временное проживание (для лиц без гражданства)' },
            { value: '11', text: 'Удостоверение беженца' },
            { value: '12', text: 'Миграционная карта' },
            { value: '13', text: 'Паспорт гражданина СССР' },
            { value: '14', text: 'CНИЛС' },
            { value: '21', text: 'ИНН' },
            { value: '22', text: 'Водительское удостоверение' },
            { value: '24', text: 'Свидетельство о регистрации транспортного средства в органах Министерства внутренних дел Российской Федерации' },
            { value: '25', text: 'Охотничий билет' },
            { value: '26', text: 'Разрешение на хранение и ношение охотничьего оружия' },
            { value: '28', text: 'Загранпаспорт' },
            { value: '29', text: 'Свидетельство о предоставлении временного убежища на территории Российской Федерации' },
            { value: '30', text: 'Свидетельство о рассмотрении ходатайства по существу' },
            { value: '99', text: 'Иной' },
          ],
        },
      }
    },
    computed: {
      comission_hint: function () {
        this.check_comission()
        return 'Комиссия: ' + Number(this.comission).toFixed(2) + ', итого: ' + Number(Number(this.comission) + Number(this.form.sum)).toFixed(2)
      },
    },
    watch: {
      service: function () {
        this.load_service()
        this.load_payers()
      },
    },
    mounted: function () {
      this.load_payers()
      this.load_service()
    },
    methods: {
      get_value: function (settings, key) {
        if (settings.filter(a => a.key == key)[0]) {
          return settings.filter(a => a.key == key)[0].default_value
        }
        return ''
      },
      doc_change: function (item) {
        this.form.payer.doc = JSON.parse(JSON.stringify(item))
      },
      name_change: function (item) {
        if (!item) {
          this.form.payer = {
            doc: {},
          }
        } else {
          this.form.payer = JSON.parse(JSON.stringify(item))
          this.selected.doc = this.form.payer.doc
        }
      },
      load_service: function () {
        if (this.service) {
          this.axios.post('/api/item/list', {
            id: this.service,
          })
            .then(response => {
              if (!response.data.error) {
                const service = response.data.data[0]
                if (service) {
                  const settings = service.settings
                  this.form.recipient.name = service.recipient_item.requisites.name// this.get_value(settings, 'recipient_name')
                  this.form.recipient.name_full = service.recipient_item.legal.name.full// this.get_value(settings, 'recipient_name')
                  this.form.recipient.name_short = service.recipient_item.name
                  this.form.recipient.inn = service.recipient_item.legal.inn// this.get_value(settings, 'recipient_inn')
                  this.form.recipient.kpp = service.recipient_item.legal.kpp// this.get_value(settings, 'recipient_kpp')
                  this.form.recipient.bankname = service.recipient_item.requisites.bank_name// this.get_value(settings, 'bank_name')
                  this.form.recipient.bik = service.recipient_item.requisites.bic// this.get_value(settings, 'bank_bic')
                  this.form.recipient.ks = service.recipient_item.requisites.ks// this.get_value(settings, 'bank_ks')
                  this.form.recipient.accnumber = service.recipient_item.requisites.rs// this.get_value(settings, 'account')
                  this.form.recipient.oktmo = this.get_value(settings, 'oktmo')
                  this.form.recipient.kbk = this.get_value(settings, 'kbk')
                  this.form.description = this.get_value(settings, 'dest')
                  this.form.recipient.uin = this.get_value(settings, 'uin')
                  this.form.client = service.client
                  this.service_item = service
                  console.log(this.form)
                }
              } else {
                this.$store.commit('snackbar', response.data.data)
              }
            })
            .catch(e => {
              this.$store.commit('snackbar', e)
            })
        }
      },
      load_payers: function () {
        this.axios
          .post('/api/member/list', {
            // client: this.form.client
          })
          .then(response => {
            if (!response.data.error) {
              for (const x in response.data.data) {
                for (const y in response.data.data[x].documents) {
                  response.data.data[x].documents[y].type_name = this.dict.doc_type[response.data.data[x].documents[y].type]
                }
              }
              this.select.payers = response.data.data
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', e)
          })
      },
      check_doc: function (type, number, bik) {
        if (type == 21) {
          const error = {}
          if (this.validateInn(number, error)) return true
          else return error.message
        }
        if (type == 14) {
          const error = {}
          if (this.validateSnils(number, error)) return true
          else return error.message
        }
        if (type == 'kpp') {
          const error = {}
          if (this.validateKpp(number, error)) return true
          else return error.message
        }
        if (type == 'rs') {
          const error = {}
          if (this.validateRs(number, bik, error)) return true
          else return error.message
        }
        if (type == 'ks') {
          const error = {}
          if (this.validateKs(number, bik, error)) return true
          else return error.message
        }
        return true
      },
      validateRs: function (rs, bik, error) {
        var result = false
        if (typeof rs === 'number') {
          rs = rs.toString()
        } else if (typeof rs !== 'string') {
          rs = ''
        }
        if (!rs.length) {
          error.code = 1
          error.message = 'Р/С пуст'
        } else if (/[^0-9]/.test(rs)) {
          error.code = 2
          error.message = 'Р/С может состоять только из цифр'
        } else if (rs.length !== 20) {
          error.code = 3
          error.message = 'Р/С может состоять только из 20 цифр'
        } else {
          var bikRs = bik.toString().slice(-3) + rs
          if (bik.toString().slice(-3) == '000' || bik.toString().slice(-3) == '001' || bik.toString().slice(-3) == '002') { bikRs = bik.toString().slice(4, 6).padStart(3, '0') + rs }
          var checksum = 0
          var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]
          for (var i in coefficients) {
            checksum += coefficients[i] * (bikRs[i] % 10)
          }
          if (checksum % 10 === 0) {
            result = true
          } else {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
      validateKs (ks, bik, error) {
        var result = false
        if (this.validateBik(bik, error)) {
          if (typeof ks === 'number') {
            ks = ks.toString()
          } else if (typeof ks !== 'string') {
            ks = ''
          }
          if (!ks.length) {
            error.code = 1
            error.message = 'К/С пуст'
          } else if (/[^0-9]/.test(ks)) {
            error.code = 2
            error.message = 'К/С может состоять только из цифр'
          } else if (ks.length !== 20) {
            error.code = 3
            error.message = 'К/С может состоять только из 20 цифр'
          } else {
            var bikKs = '0' + bik.toString().slice(4, 6) + ks
            var checksum = 0
            var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]
            for (var i in coefficients) {
              checksum += coefficients[i] * (bikKs[i] % 10)
            }
            if (checksum % 10 === 0) {
              result = true
            } else {
              error.code = 4
              error.message = 'Неправильное контрольное число'
            }
          }
        }
        return result
      },
      validateBik (bik, error) {
        var result = false
        if (typeof bik === 'number') {
          bik = bik.toString()
        } else if (typeof bik !== 'string') {
          bik = ''
        }
        if (!bik.length) {
          error.code = 1
          error.message = 'БИК пуст'
        } else if (/[^0-9]/.test(bik)) {
          error.code = 2
          error.message = 'БИК может состоять только из цифр'
        } else if (bik.length !== 9) {
          error.code = 3
          error.message = 'БИК может состоять только из 9 цифр'
        } else {
          result = true
        }
        return result
      },
      validateKpp (kpp, error) {
        var result = false
        if (typeof kpp === 'number') {
          kpp = kpp.toString()
        } else if (typeof kpp !== 'string') {
          kpp = ''
        }
        if (!kpp.length) {
          error.code = 1
          error.message = 'КПП пуст'
        } else if (kpp.length !== 9) {
          error.code = 2
          error.message = 'КПП может состоять только из 9 знаков (цифр или заглавных букв латинского алфавита от A до Z)'
        } else if (!/^[0-9]{4}[0-9A-Z]{2}[0-9]{3}$/.test(kpp)) {
          error.code = 3
          error.message = 'Неправильный формат КПП'
        } else {
          result = true
        }
        return result
      },
      validateSnils (snils, error) {
        var result = false
        if (typeof snils === 'number') {
          snils = snils.toString()
        } else if (typeof snils !== 'string') {
          snils = ''
        }
        if (!snils.length) {
          error.code = 1
          error.message = 'СНИЛС пуст'
        } else if (/[^0-9]/.test(snils)) {
          error.code = 2
          error.message = 'СНИЛС может состоять только из цифр'
        } else if (snils.length !== 11) {
          error.code = 3
          error.message = 'СНИЛС может состоять только из 11 цифр'
        } else {
          var sum = 0
          for (var i = 0; i < 9; i++) {
            sum += parseInt(snils[i]) * (9 - i)
          }
          var checkDigit = 0
          if (sum < 100) {
            checkDigit = sum
          } else if (sum > 101) {
            checkDigit = parseInt(sum % 101)
            if (checkDigit === 100) {
              checkDigit = 0
            }
          }
          if (checkDigit === parseInt(snils.slice(-2))) {
            result = true
          } else {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
      validateInn: function (inn, error) {
        var result = false
        if (typeof inn === 'number') {
          inn = inn.toString()
        } else if (typeof inn !== 'string') {
          inn = ''
        }
        if (!inn.length) {
          error.code = 1
          error.message = 'ИНН пуст'
        } else if (/[^0-9]/.test(inn)) {
          error.code = 2
          error.message = 'ИНН может состоять только из цифр'
        } else if ([10, 12].indexOf(inn.length) === -1) {
          error.code = 3
          error.message = 'ИНН может состоять только из 10 или 12 цифр'
        } else {
          var checkDigit = function (inn, coefficients) {
            var n = 0
            for (var i in coefficients) {
              n += coefficients[i] * inn[i]
            }
            return parseInt(n % 11 % 10)
          }
          switch (inn.length) {
            case 10:
              var n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8])
              if (n10 === parseInt(inn[9])) {
                result = true
              }
              break
            case 12:
              var n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8])
              var n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8])
              if ((n11 === parseInt(inn[10])) && (n12 === parseInt(inn[11]))) {
                result = true
              }
              break
          }
          if (!result) {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
      check_comission: function () {
        this.axios
          .post('/api/order/comission', this.form)
          .then(response => {
            if (!response.data.error) {
              this.comission = Number(response.data.data)
            } else {
              this.$store.commit(
                'snackbar',
                response.data.data || response.data.message || 'Ошибка при сохранении данных'
              )
            }
          }
          )
          .catch(e => {
            this.$store.commit('snackbar', e)
          })
      },
      bank_input: function () {
        this.check_comission()
        if (!this.suggestion.bank) {
          this.suggestion.bank = true
          $('[name=bank_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.recipient.bankname = data.data.name.full || data.data.name.payment
              this.form.recipient.bik = data.data.bic
              this.form.recipient.ks = data.data.correspondent_account
            },
          })
          $('[name=bank_bik]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.recipient.bankname = data.data.name.full || data.data.name.payment
              this.form.recipient.bik = data.data.bic
              this.form.recipient.ks = data.data.correspondent_account
            },
          })
          $('[name=bank_ks]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.recipient.bankname = data.data.name.full || data.data.name.payment
              this.form.recipient.ks = data.data.ks
              this.form.recipient.bik = data.data.correspondent_account
            },
          })
        }
      },
      recipient_input: function () {
        this.check_comission()
        if (!this.suggestion.recipient) {
          this.suggestion.recipient = true
          $('[name=recipient_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.recipient.name = data.data.name.short_with_opf
              this.form.recipient.name_full = data.data.name.short_with_opf
              this.form.recipient.name_short = data.data.name.short
              this.form.recipient.inn = data.data.inn
              this.form.recipient.kpp = data.data.kpp
            },
          })
          $('[name=recipient_kpp]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.recipient.name = data.data.name.short_with_opf
              this.form.recipient.name_full = data.data.name.short_with_opf
              this.form.recipient.name_short = data.data.name.short
              this.form.recipient.inn = data.data.inn
              this.form.recipient.kpp = data.data.kpp
            },
          })
          $('[name=recipient_inn]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.recipient.name = data.data.name.short_with_opf
              this.form.recipient.name_full = data.data.name.short_with_opf
              this.form.recipient.name_short = data.data.name.short
              this.form.recipient.inn = data.data.inn
              this.form.recipient.kpp = data.data.kpp
            },
          })
        }
      },
      open_file: function (id) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/payments/receipt',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      resend: function () {
        this.form.id = ''
        this.form.state = 0
        this.dialog.create = true
        this.dialog.view = false
      },
      receipt: function () {
        for (const x in this.form.payments) {
          // if (this.form.payments[x].receipt) {
          this.open_file(this.form.payments[x].payment_order)
          // }
        }
      },
      recall: function (item) {
        this.axios
          .post('/api/orders/revoke', { orderid: item.id, date: item.date, time: item.time })
          .then(response => {
            if (!response.data.error) {
              this.confirm.show = false
              this.state.show = true
              this.state.item = { state: response.data.status }
            } else {
              this.$store.commit(
                'snackbar',
                response.data.data || response.data.message || 'Ошибка при сохранении данных'
              )
            }
          }
          )
          .catch(e => {
            this.$store.commit('snackbar', e)
          })
      },
      address_input: function () {
        if (!this.suggestion.address) {
          this.suggestion.address = true
          $('[name=address]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              this.form.payer.address = data.unrestricted_value
              this.form.payer.address_data = data.data
            },
          })
        }
      },
      name_filter: function (item, query, text) {
        if (item.fullname.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.doc && item.doc.series.indexOf(query.toUpperCase()) > -1) return true
        if (item.doc && item.doc.number.indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      oktmo_filter: function (item, query, text) {
        if (item.name.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.number.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      transform_order: function (form) {
        const item = this.service_item
        item.count = 1
        item.amount = form.sum
        // item.name = form.recipient.name
        item.client = form.client
        item.attributes = {
          recipient_name: form.recipient.name,
          recipient_name_full: form.recipient.name_full,
          recipient_name_short: form.recipient.name_short,
          recipient_inn: form.recipient.inn,
          recipient_kpp: form.recipient.kpp,
          bank_name: form.recipient.bankname,
          bank_bic: form.recipient.bik,
          bank_ks: form.recipient.ks,
          recipient_rs: form.recipient.accnumber,
          oktmo: form.recipient.oktmo,
          kbk: form.recipient.kbk,
          dest: form.description,
          uin: form.recipient.uin,
          payer_fio: form.payer.fullname,
          payer_address: form.payer.address,
          doc_type: form.payer.doc.type,
          payer_doc_series: form.payer.doc.series,
          payer_doc_number: form.payer.doc.number,
          payer_phone: form.payer.phone,
          payer_email: form.payer.email,
        }
        const order = {
          client: form.client,
          items: [
            item,
          ],
          member_item: form.payer,
          sum: {
            comission: Number(this.comission).toFixed(2),
            recipient: Number(form.sum).toFixed(2),
            full: (Number(form.sum) + Number(this.comission)).toFixed(2),
          },
        }
        return order
      },
      create: function () {
        let request = JSON.parse(JSON.stringify(this.form))
        request = this.transform_order(request)
        this.axios
          .post('/api/order/create/', request)
          .then(response => {
            this.load_payers()
            if (!response.data.error) {
              this.$store.commit('snackbar', 'Успешно')
              this.state.show = true
              this.state.item = { state: 2000 }
              this.form = {
                recipient: {

                },
                payer: {
                  doc: {
                    type: '',
                    series: '',
                    number: '',
                  },
                },
              }
            } else {
              this.$store.commit(
                'snackbar',
                response.data.data || response.data.status_message || 'Ошибка при сохранении данных'
              )
            }
          })
          .catch(e => {
            this.load_payers()
            this.$store.commit('snackbar', e)
          })
      },
    },
  }
        </script>
<!--        <style>
  .v-textarea textarea {
    line-height: 1.2em;
  }
  .v-input input {
    max-height: 24px;
  }
</style>-->
